import { Divider, Input } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import styled, { css } from "styled-components";
import {
  enterFromBottom,
  enterLeft,
  enterTop,
} from "../Services/Sales/Checkout/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  min-height: auto;
  padding-top: calc(72px + 24px);
  padding-left: 90px;
  padding-right: 90px;
  padding-bottom: 40px;
  gap: 28px;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
`;

export const Card = styled.div`
  background: #fff;
  padding: 32px;
  border: 2px solid #f1f5f9;
  border-radius: 8px;
  box-shadow:
    1px 8px 20px 0px #c1c6cd17,
    -1px -1px 4px 0px #c1c6cd14;

  width: 880px;
  text-align: center;
  overflow-y: auto;
  margin: 0 auto;
  animation: ${enterTop} 0.5s ease-in-out;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-family: "Open sans", sans-serif;
  font-weight: bold;
  line-height: 100%;
  color: rgba(0, 34, 68, 1);
  margin-bottom: 8px;

  ${({ results }) =>
    results &&
    css`
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #314158;
      animation: ${enterLeft} 0.75s ease-in-out;
    `}
`;
export const BackButton = styled(Link)`
  position: absolute;
  top: 100px;
  left: 80px;
  font-size: 16px;
  color: rgba(98, 116, 142, 1);
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;

  ${({ noPosition }) =>
    noPosition &&
    css`
      position: unset;
    `}
`;
export const BackIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackSpan = styled.p`
  margin-bottom: 0;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #314158;
  span {
    color: #62748e;
    font-weight: 400;
  }
`;

export const ErrorSubtitle = styled.p`
  color: red;
  margin-top: 8px;
  margin-bottom: 32px;
  font-family: "Inter";
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  display: flex;
  justify-content: flex-start;
`;

export const Subtitle = styled.p`
  color: rgba(98, 116, 142, 1);
  margin-bottom: 32px;

  font-family: "Inter";
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;

  ${({ results }) =>
    results &&
    css`
      margin-bottom: 16px;
      color: rgba(49, 65, 88, 1);
      font-weight: 600;
      animation: ${enterLeft} 0.75s ease-in-out;
    `}
`;
export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledInput = styled(Input)`
  flex: 1;
  padding: 12px;
  border: 1.5px solid #dfdfe0;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 0px #19191c0a;

  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0px;

  &::placeholder {
    color: #68686e;
  }
`;

export const SearchButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  width: 50px;
  height: 38px;
  border-radius: 10px;
  background-color: #11a7d9;
  box-shadow: 0px 1px 2px 0px #19191c0a;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ResultContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 120px;
  min-height: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const ResultContent = styled.div`
  width: 880px;
  height: 400px;
  overflow-y: auto;
`;

export const ResultTitle = styled.h3`
  font-weight: bold;
  margin-bottom: 8px;
`;

export const ResultSubtitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
`;
export const ResultCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ hasCredential }) =>
    hasCredential ? "2px solid rgb(57, 178, 100)" : "2px solid #e2e8f0"};
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  opacity: 0;

  ${({ index }) =>
    index &&
    css`
      animation: ${enterFromBottom} 0.5s ease-in-out ${`${index * 100}ms`}
        forwards;
    `}
`;

export const NumberCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #11a7d9;
  font-weight: bold;
  font-size: 14px;
  font-family: "Inter", sans-serif;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const InfosClient = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CodeText = styled.span`
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  line-height: 100%;
  color: rgba(98, 116, 142, 1);
`;

export const BoothContainer = styled.div`
  display: flex;
  width: 220px;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

export const BoothTitle = styled.span`
  font-size: 16px;
  font-family: "Inter", sans-serif;
  line-height: 100%;
  font-weight: 600;
  color: rgba(98, 116, 142, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #11a7d9;
  }
`;

export const BoothText = styled.span`
  font-size: 14px;
  font-family: "Inter", sans-serif;
  line-height: 100%;
  font-weight: 400;
  color: rgba(98, 116, 142, 1);
  margin-left: 5px;
`;

export const StartServiceButton = styled.button`
  display: flex;
  align-items: center;
  background: #11a7d9;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  transition: all 300ms ease-in-out;
  height: 30px;
  box-shadow: 0px 1px 2px 0px #19191c0a;
  gap: 8px;

  &:hover {
    background: rgb(14, 134, 174);
    svg {
      transform: translateX(3.5px);
    }
  }

  svg {
    transition: all 300ms ease-in-out;
  }
`;
export const NotFoundSearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: auto;
  text-align: center;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

export const NotFoundSearchText = styled.p`
  color: rgba(2, 6, 24, 1);
  font-size: 18px;
  margin-top: 20px;
  font-family: "Inter", sans-serif;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 16px;
    width: 100%;
    margin-bottom: 200px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 300px;
  }
`;

export const ResultCardContainer = styled.div`
  display: grid;
  gap: 8px;
  margin-bottom: 24px;
`;

export const CredentialIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 35%;
  background-color: ${({ hasCredential }) =>
    hasCredential ? "rgb(211, 246, 218)" : "rgb(240, 240, 240)"};
  color: ${({ hasCredential }) =>
    hasCredential ? "rgb(21, 173, 75)" : "rgb(136, 136, 137)"};
  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;

export const CredentialInfo = styled.div`
  display: flex;
  font-size: 14px;
  color: ${({ hasCredential }) =>
    hasCredential ? "rgb(21, 173, 75)" : "rgb(136, 136, 137)"};
  font-family: "Inter", sans-serif;
  width: 100%;
  font-weight: 500;
  align-items: center;
  gap: 6px;
  height: auto;
  margin-left: 12px;
  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

export const AccountTypeBadgeStyled = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  padding: 2px 10px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  white-space: nowrap;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const DividerStyled = styled(Divider)`
  height: 100% !important;

  &.ant-divider-vertical {
    margin: 0 20px;
    border-inline-start-width: 2px;
    border-inline-start-color: rgba(98, 116, 142, 0.3);
  }
`;

export const ContractText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContractsTextWithPreviewCountsTotals = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const ButtonSearchCredentials = styled.button`
  margin-left: 58px;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  color: #11a7d9;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
`;
